export const INPUT_TYPE_MAP = {
  text: '文本',
  number: '数字',
  password: '密码',
};

export const INPUT_VERIFY_MAP = {
  none: '无',
  email: '邮箱',
  url: 'URL',
  phone: '手机号',
  qq: 'QQ号',
  zip: '邮政编码',
  idCard: '身份证号',
};
